export default __webpack_public_path__ + "static/media/Dr.Elizabeth_Sully.c95115be.png";